var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_268_13573)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_13573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3404 16.1392V15.8183L31.3306 15.4928C31.2304 13.8403 30.349 13 28.7067 13H21.6338C19.9916 13 19.1101 13.8403 19.0099 15.4928L19.0002 15.8565V16.1392V33.8608V34.5041C19.0443 35.2619 19.256 35.8373 19.6248 36.2515C20.0643 36.7464 20.7403 36.9995 21.6338 36.9995H28.7067C29.6002 36.9995 30.2763 36.7458 30.7158 36.2515C31.0846 35.8368 31.2963 35.2608 31.3404 34.5041V33.8608V16.1392ZM24.0337 14.5464H26.3069C26.4564 14.5464 26.5775 14.6434 26.5775 14.7629C26.5775 14.8824 26.4564 14.9794 26.3069 14.9794H24.0337C23.8843 14.9794 23.7631 14.8824 23.7631 14.7629C23.7631 14.6434 23.8843 14.5464 24.0337 14.5464ZM25.1703 36.3876C24.9904 36.3876 24.8146 36.3343 24.6651 36.2344C24.5156 36.1345 24.399 35.9925 24.3302 35.8263C24.2614 35.6602 24.2434 35.4773 24.2785 35.301C24.3136 35.1246 24.4002 34.9626 24.5273 34.8354C24.6545 34.7082 24.8165 34.6216 24.9929 34.5865C25.1693 34.5515 25.3521 34.5695 25.5183 34.6383C25.6844 34.7071 25.8264 34.8237 25.9263 34.9732C26.0262 35.1227 26.0796 35.2985 26.0796 35.4783C26.0795 35.7195 25.9837 35.9507 25.8132 36.1213C25.6427 36.2918 25.4114 36.3876 25.1703 36.3876ZM30.5827 33.8763H19.7579V16.1237H30.5827V33.8763Z",
    fill: "#21AA47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_268_13573",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_268_13573"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0 0.203922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_268_13573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_268_13573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_13573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3405,
    height: 24,
    fill: "white",
    transform: "translate(19 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPhoneIcon);
export default __webpack_public_path__ + "static/media/green-phone-icon.56aa0731349d234040d385346485d518.svg";
export { ForwardRef as ReactComponent };